<template>
  <div class="eui-o-pdfPreview" :class="{ 'preview-enabled': isPreviewEnabled }">
    <ScrollingDocument
        :ref="`scrollingDocument-${uid}`"
        class="eui-o-pdfPreview__pages"
        @pages-fetch="onPagesFetch"
        v-bind="{pages, pageCount, currentPage }"
        v-slot="{page, isPageFocused}"
        :is-parent-visible="isPreviewEnabled">
      <PDFThumbnail class="eui-o-pdfPreview__page"
                    v-bind="{scale, page, isPageFocused, currentPage}"
                    :signsCount="getSignsCount(page.pageNumber) + getParaphsCount()"
                    @thumbnail-rendered="onThumbnailRendered"
                    @thumbnail-errored="onThumbnailErrored"
                    @page-focus="onPageFocused"/>
    </ScrollingDocument>
  </div>
</template>

<script>
import ScrollingDocument from './ScrollingDocument';
import PDFThumbnail from './PDFThumbnail';

export default {
  name: 'PDFPreview',

  components: {
    ScrollingDocument,
    PDFThumbnail,
  },

  props: {
    pages: {
      required: true,
    },
    pageCount: {
      type: Number,
      default: 0,
    },
    scale: {
      type: Number,
      default: 1.0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    isPreviewEnabled: {
      default: false,
    },
    signsList: {
      required: false,
      default: () => [],
    }
  },

  computed: {
    uid() {
      return this._uid;
    }
  },

  methods: {
    onPagesFetch(currentPage) {
      this.$parent.$emit('pages-fetch', currentPage);
    },

    onPageFocused(pageNumber) {
      this.$emit('update:currentPage', pageNumber);
      this.$emit('page-focus', pageNumber);
      this.$parent.$emit('page-focus', pageNumber);
    },

    onThumbnailRendered(payload) {
      this.$el.dispatchEvent(new Event('scroll'));
      this.$parent.$emit('thumbnail-rendered', payload);
    },

    onThumbnailErrored(payload) {
      this.$parent.$emit('thumbnail-errored', payload);
    },

    getSignsCount(pageNumber) {
      return this.signsList.filter((sign) => sign.zone.position.page === pageNumber).length;
    },

    getParaphsCount() {
      return this.signsList.filter((sign) => sign.zone.zoneType === 'paraph').length;
    }
  },
};
</script>

<style scoped>
.scrolling-page {
  margin-bottom: 1em;
}

@media print {
  .pdf-preview {
    display: none;
  }
}
</style>
